
export default {
monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
customFormatter(date, format) {
	let fDate = new Date(date);

	if (format == 'dash') {
		return (fDate.getMonth() + 1) + '-' + fDate.getDate() + '-' + fDate.getFullYear();
	}
	else if (format == 'slash') {
		return (fDate.getMonth() + 1) + '/' + fDate.getDate() + '/' + fDate.getFullYear();
	}
	else if (format == 'full-slash') {
		return ('0' + (fDate.getMonth() + 1)).slice(-2) + '/' + ('0' + fDate.getDate()).slice(-2) + '/' + fDate.getFullYear();
	}
	else {
		return (fDate.getMonth() + 1) + '/' + fDate.getDate() + '/' + fDate.getFullYear();
	}
		
},
	formatDate(date) {
		let fDate = new Date(date);
		return this.monthNames[fDate.getMonth()] + ' ' + fDate.getDate() + ', ' + fDate.getFullYear();
	},
};